<template>
    <div class="content">
        <div v-if="!showExcel">
          <div class="row">
            <div class="col-sm-12 col-md-6"></div>
            <div class="col-sm-12 col-md-6">
              <div class="datatable_filter float-right">
                <div class="row">
                  <div class="col">
                    <div class="form-check">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        id="showNextContactToday"
                        v-model="filter.archive"
                        @change="fetchExcels"
                        true-value="1"
                        false-value="0"
                      >
                      <label class="form-check-label" for="showNextContactToday">Показать архив</label>
                    </div>
                  </div>
                  <div class="col">
                    <label>
                      <select v-model="tableData.length" @change="fetchExcels()" class="form-control form-control-sm">
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                      </select>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
              <div class="card-header">
                  Список импортов
              </div>
              <div class="table-responsive">
                <table class="table table-hover table-bordered bg-white table-striped">
                    <thead>
                        <th>#</th>
                        <th>Действия</th>
                        <th>Названия файла</th>
                        <th>Автор</th>
                        <th class="text-center">Статус</th>
                        <th>Тип</th>
                        <th>Количество</th>
                        <th>Ошибка</th>
                        <th>Дата загрузки</th>
                    </thead>
                    <tbody>
                      <template v-if="!loadExcels">
                        <tr v-for="(excel, index) in excels" :key="excel.id">
                          <td>{{index+1}}</td>
                          <td>
                            <div class="btn-group">
                              <router-link v-if="!excel.deleted_at" :to="{ name: 'adminOldImportReport', params: { id: excel.id } }" class="btn btn-info btn-sm" title="Посмотреть отчет">
                                <i class="fa fa-eye"></i>
                              </router-link>
                              <button
                                @click.prevent="handleDelete(excel.id)"
                                class="btn btn-danger btn-sm "
                                v-if="!excel.deleted_at"
                                :disabled="isProcessing"
                                title="Удалить"
                              >
                                <i class="fa fa-trash"></i>
                              </button>
                              <button
                                @click.prevent="restoreExcel(excel.id)"
                                class="btn btn-success btn-sm "
                                v-if="excel.deleted_at"
                                :disabled="isProcessing"
                                title="Восстановить"
                              >
                                Восстановить
                              </button>
                              <button
                                @click.prevent="handleForceDelete(excel.id)"
                                class="btn btn-danger btn-sm "
                                v-if="excel.deleted_at"
                                :disabled="isProcessing"
                                title="Окончательно удалить"
                              >
                                <i class="fa fa-trash-o"></i>
                              </button>
                            </div>
                          </td>
                          <td>{{excel.original_filename}}</td>
                          <td>{{excel.user ? `${excel.user.fullname}`: '' }}</td>
                          <td class="text-center">
                            <i class="fa fa-play text-info fa-lg" aria-hidden="true" v-if="excel.status == 'started'" :title="`Задание началось ${excel.created_at}`"></i>
                            <i class="fa fa-check text-success fa-lg" aria-hidden="true" v-if="excel.status == 'done'" title="Задание завершено успешно"></i>
                            <i class="fa fa-times text-danger fa-lg" aria-hidden="true" v-if="excel.status == 'failed'" title="Задание завершено с ошибками"></i>
                          </td>
                          <td>
                            <span v-if="excel.type == 'import_debtors'">Импорт новых должников</span>
                            <span v-if="excel.type == 'update_debts'">Обновить договоры</span>
                            <span v-if="excel.type == 'distribution_debts'">Распределение договоров</span>
                            <span v-if="excel.type == 'delete_debts'">Отправить договоры в АРХИВ</span>
                            <span v-if="excel.type == 'add_payments'">Добавить платежы</span>
                            <span v-if="excel.type == 'add_additional_data'">Добавить доп. данные</span>
                          </td>
                          <td>
                            <span>Все: <strong>{{excel.count}}</strong><br></span>
                            <span v-if="excel.type == 'add_additional_data'" class="text-success">Успешно выполнено: <strong>{{excel.import_debtors_count}}</strong><br></span>
                            <span v-if="excel.type == 'import_debtors'" class="text-success">Успешно выполнено: <strong>{{excel.successfully_imported_debtors_count}}</strong><br></span>
                            <span v-if="excel.type == 'update_debts'" class="text-success">Успешно выполнено: <strong>{{excel.successfully_imported_debts_count}}</strong><br></span>
                            <span v-if="excel.type == 'delete_debts'" class="text-success">Успешно выполнено: <strong>{{excel.successfully_deleted_debts_count}}</strong><br></span>
                            <span v-if="excel.type == 'distribution_debts'" class="text-success">Успешно выполнено: <strong>{{excel.successfully_distribution_debts_count}}</strong><br></span>
                            <span v-if="excel.type == 'add_payments'" class="text-success">Успешно выполнено: <strong>{{excel.successfully_imported_payments_count}}</strong><br></span>

                            <span v-if="excel.type == 'import_debtors'" class="text-danger">Выполнено с ошибкой: <strong>{{excel.failed_imported_debtors_count}}</strong><br></span>
                            <span v-if="excel.type == 'update_debts'" class="text-danger">Выполнено с ошибкой: <strong>{{excel.failed_imported_debts_count}}</strong><br></span>
                            <span v-if="excel.type == 'delete_debts'" class="text-danger">Выполнено с ошибкой: <strong>{{excel.failed_deleted_debts_count}}</strong><br></span>
                            <span v-if="excel.type == 'distribution_debts'" class="text-danger">Выполнено с ошибкой: <strong>{{excel.failed_distribution_debts_count}}</strong><br></span>
                            <span v-if="excel.type == 'add_payments'" class="text-danger">Выполнено с ошибкой: <strong>{{excel.failed_imported_payments_count}}</strong><br></span>

                            <span v-if="excel.type == 'import_debtors'" class="text-warning">Без изменений: <strong>{{excel.count - (excel.successfully_imported_debtors_count + excel.failed_imported_debtors_count)}}</strong><br></span>
                            <span v-if="excel.type == 'update_debts'" class="text-warning">Без изменений: <strong>{{excel.count - (excel.successfully_imported_debts_count + excel.failed_imported_debts_count)}}</strong><br></span>
                            <span v-if="excel.type == 'delete_debts'" class="text-warning">Без изменений: <strong>{{excel.count - (excel.successfully_deleted_debts_count + excel.failed_deleted_debts_count)}}</strong><br></span>
                            <span v-if="excel.type == 'distribution_debts'" class="text-warning">Без изменений: <strong>{{excel.count - (excel.successfully_distribution_debts_count + excel.failed_distribution_debts_count)}}</strong><br></span>
                            <span v-if="excel.type == 'add_payments'" class="text-warning">Без изменений: <strong>{{excel.count - (excel.successfully_imported_payments_count + excel.failed_imported_payments_count)}}</strong><br></span>
                          </td>
                          <td>{{excel.errors}}</td>
                          <td>{{excel.created_at| datetimeFormat }}</td>
                        </tr>
                      </template>
                      <tr v-if="loadExcels">
                        <td colspan="11" class="text-center">
                          <loader-wave/>
                        </td>
                      </tr>
                    </tbody>
                </table>
              </div>
          </div>
          <pagination :pagination="pagination" :offset="4" @paginate="fetchExcels()"/>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      excels: [],
      action: '',
      files: [],
      fileProgress: 0,
      fileCurrent: '',
      errors: {},
      loadExcels: false,
      isProcessing: false,
      showExcel: false,
      tableData: {
        draw: 0,
        length: 10,
        search: '',
        column: 0,
        dir: 'asc',
      },
      filter: {
        archive: 0,
        user_id: '',
      },
      pagination: {
        current_page: 1,
      },
    };
  },
  computed: {
    ...mapGetters([
      'permissions'
    ]),
  },
  mounted() {
    this.fetchExcels();
  },
  methods: {
    fetchExcels() {
      this.loadExcels = true;
      this.tableData.draw += 1;

      const requests = { ...this.tableData, ...this.filter };
      window.axios.get(`http://imports.kfn.kz/api/admin/imports/excels?page=${this.pagination.current_page}`, { params: requests })
        .then((res) => {
          if (this.tableData.draw === res.data.draw) {
            this.excels = res.data.excels.data;
            console.log(this.excels);
            this.pagination = this.laraPaginate(res.data.excels);
          } else {
            console.log('failed');
          }
          this.loadExcels = false;
        });
    },

    clearFileInput() {
      this.errors = {};
      this.files = [];
      this.action = '';
      this.fileProgress = 0;
      this.fileCurrent = '';
      this.$refs.files.value = '';
    },

    async fileInputChange() {
      this.files = [];
      this.fileProgress = 0;
      this.fileCurrent = '';

      let items = Array.from(event.target.files);
      for (let item of items) {
        this.files.push(item);
      }
    },

    async fileInputSubmit(evt) {
      evt.preventDefault();
      for (let item of this.files) {
        await this.uploadFile(item);
      }
    },

    async uploadFile(item) {
      let form = new FormData();
      form.append('file', item);
      form.append('action', this.action);
      this.isProcessing = true;
      await window.axios.post('http://imports.kfn.kz/api/admin/imports/file', form, {
        onUploadProgress: (itemUpload) => {
          this.fileProgress = Math.round((itemUpload.loaded / itemUpload.total) * 100);
          this.fileCurrent = `${item.name} ${this.fileProgress}%`;
        }
      }).then((res) => {
        if (res.data.success) {
          window.Swal.fire('Успешно выполнено!', 'Файл успешно загружен в сервер', 'success');
          this.clearFileInput();
          this.fetchExcels();
        }
      }).catch((err) => {
        this.errors = this.laravelValidation(err);
      }).finally(() => {
        this.isProcessing = false;
      });
    },

    handleDelete(id) {
      window.Swal.fire({
        title: 'Вы уверены?',
        text: 'Вы действительно хотите удалить',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Да, удали это!',
        cancelButtonText: 'Отмена',
      }).then((result) => {
        if (result.value) {
          this.isProcessing = true;
          this.deleteExcel(id);
        }
      });
    },

    handleForceDelete(id) {
      window.Swal.fire({
        title: 'Вы уверены?',
        text: 'Вы действительно хотите удалить данные без возможности восстановления',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Да, удали это!',
        cancelButtonText: 'Отмена',
      }).then((result) => {
        if (result.value) {
          this.isProcessing = true;
          this.forceDeleteExcel(id);
        }
      });
    },

    deleteExcel(id) {
      window.axios.delete(`http://imports.kfn.kz/api/admin/imports/excels/${id}`)
        .then((res) => {
          if (res.status === 204) {
            window.Swal.fire('Успешно выполнено!', res.data.message, 'success');
            this.fetchExcels();
          }
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },

    restoreExcel(id) {
      window.axios.put(`http://imports.kfn.kz/api/admin/imports/excels/${id}/restore`)
        .then((res) => {
          if (res.status === 202) {
            window.Swal.fire('Успешно выполнено!', res.data.message, 'success');
            this.fetchExcels();
          }
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },

    forceDeleteExcel(id) {
      window.axios.delete(`http://imports.kfn.kz/api/admin/imports/excels/${id}/forcedelete`)
        .then((res) => {
          if (res.status === 204) {
            window.Swal.fire('Успешно выполнено!', res.data.message, 'success');
            this.fetchExcels();
          }
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },
  },
};
</script>
